// extracted by mini-css-extract-plugin
module.exports = {"Icon":"Icon_Icon__9RCS8","baseline":"Icon_baseline__1iP3i","bottom":"Icon_bottom__2j2Ve","middle":"Icon_middle__T3Qxo","top":"Icon_top__tT4oP"};